import { useEffect, useState } from 'react';

const FetchWordPressProps = () => {
	const [props, setProps] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const [selected, setSelected] = useState('all');

	const handleFilter = (event) => {
		setSelected(event);
	}

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Build the base URL
				let url = 'https://alliedretailprop.com/wp-json/wp/v2/lab_prop?_embed&per_page=99&status=publish&orderby=title&order=asc';

				// Only add prop_type if selected !== 'all'
				if (selected !== 'all') {
					url += `&prop_type=${selected}`;
				}

				const response = await fetch(url);

				if (!response.ok) {
					throw new Error(`HTTP error: ${response.status}`);
				}

				const data = await response.json();
				setProps(data);
				setError(null);
			} catch (err) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [selected]);

	return { props, loading, error, selected, handleFilter };
}

export default FetchWordPressProps;
